import React, { Component, createRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

class Dropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: '',
            isOpened: false
        }
    }

    handleSelectDropdown = async data => {
        await this.setState({
            selected: data,
            isOpened: false
        })
        await this.props.handleChange(data);
        if (this.props.handleReset !== undefined) {
            this.props.handleReset();
        }
    }

    handleDropdown = e => {
        if (this.dropdownRef && !this.dropdownRef.current.contains(e.target)) {
            this.setState({
                isOpened: false
            })
        }
    }

    selectedValueDropdown = () => {
        if (this.props.reset) {
            return this.props.placeholder
        }
        return this.state.selected !== '' ? this.state.selected.label : this.props.placeholder
    }

    componentDidMount() {
        this.dropdownRef = createRef()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.isOpened !== this.state.isOpened) {
            if (this.state.isOpened) {
                document.addEventListener('click', this.handleDropdown)
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDropdown)
    }

    render() {
        return (
            <div id={this.props.id} className={this.state.isOpened ? "dropdown opened" : "dropdown"} tabIndex="-1">
                <div className="dropdown-select" id="btndropdown" onClick={() => this.setState({ isOpened: !this.state.isOpened })} ref={this.dropdownRef}>
                    <span className={this.state.selected !== '' && !this.props.reset ? "select truncate" : "select text-gray-500"}>
                        {this.selectedValueDropdown()}
                    </span>
                    <FontAwesomeIcon icon={faChevronDown} className="select-icon" />
                </div>
                <div className={this.state.isOpened ? "dropdown-list" : "hidden"}>
                    {
                        this.props.data.map((data, idx) =>
                            <div className="dropdown-list__item" key={idx} id="btndropdownselect" onClick={() => this.handleSelectDropdown(data)}>
                                {
                                    this.state.selected.value === data.value && !this.props.reset ?
                                        <div className="pt-3 pl-3 pr-3 bg-blue-200">
                                            <div className={this.props.data.length === idx + 1 ? "pb-3 flex justify-between items-center" : "pb-3 flex justify-between items-center border-b-2 border-gray"}>
                                                <div className="truncate">{data.label}</div>
                                            </div>
                                        </div>
                                        :
                                        <div className="pt-3 pl-3 pr-3 hover:bg-blue-100">
                                            <div className={this.props.data.length === idx + 1 ? "pb-3 flex justify-between items-center" : "pb-3 flex justify-between items-center border-b-2 border-gray"}>
                                                <div className="truncate">{data.label}</div>
                                            </div>
                                        </div>
                                }
                            </div>
                        )
                    }
                </div>
            </div>
        );
    }
}

export default Dropdown;